import {
  fetchBackmarketReviewsBreadcrumb,
  fetchBackmarketReviewsList,
  fetchBackmarketReviewsSummary,
  fetchLandingReviewsBreadcrumb,
  fetchLandingReviewsList,
  fetchLandingReviewsSummary,
  fetchMerchantReviewsBreadcrumb,
  fetchMerchantReviewsList,
  fetchMerchantReviewsSummary,
  fetchReviewsListByProductLegacy,
  fetchReviewsSummaryByProduct,
} from '@http/endpoints'

import {
  LANDING_REVIEWS,
  MERCHANT_REVIEWS,
  PRODUCT_REVIEWS,
} from '../constants'

const getConfig = ({
  landingId,
  landingSlug,
  productId,
  sellerId,
  sellerPrefix,
  sellerSlug,
  name,
  limit,
  useNewUrl,
}) => {
  let queryParams

  switch (name) {
    case MERCHANT_REVIEWS:
      // TODO: Clean this condition when the project URLs migration is completely live
      // URL-108 Clean all new urls Feature flags on review pages
      queryParams = {
        ...(useNewUrl
          ? {
              id: sellerId,
            }
          : { slug: `${sellerPrefix}/${sellerSlug}` }),
      }

      return {
        rateModule: 'merchant',
        endpoints: {
          list: fetchMerchantReviewsList,
          summary: fetchMerchantReviewsSummary,
          breadcrumb: fetchMerchantReviewsBreadcrumb,
        },
        queryParams,
      }

    case LANDING_REVIEWS: {
      const slug = `${landingSlug}.html`
      // TODO: Clean this condition when the project URLs migration is completely live
      // URL-108 Clean all new urls Feature flags on review pages
      queryParams = {
        ...(useNewUrl
          ? {
              pk: landingId,
            }
          : { slug }),
      }

      if (limit) {
        queryParams.limit = limit
      }

      return {
        rateModule: 'landing',
        endpoints: {
          list: fetchLandingReviewsList,
          summary: fetchLandingReviewsSummary,
          breadcrumb: fetchLandingReviewsBreadcrumb,
        },
        queryParams,
      }
    }

    case PRODUCT_REVIEWS:
      return {
        rateModule: 'product',
        endpoints: {
          list: fetchReviewsListByProductLegacy,
          summary: fetchReviewsSummaryByProduct,
          breadcrumb: fetchBackmarketReviewsBreadcrumb,
        },
        pathParams: { productId },
      }

    default:
      return {
        rateModule: 'backmarket',
        endpoints: {
          list: fetchBackmarketReviewsList,
          summary: fetchBackmarketReviewsSummary,
          breadcrumb: fetchBackmarketReviewsBreadcrumb,
        },
      }
  }
}

export default getConfig
